import React from "react";
import { cn } from "@/lib/utils";
import { Container } from "@/components/layout/Container";
import { MicroLabel } from "@/components/common/MicroLabel";
import { Reveal } from "@/components/common/Reveal";

/**
 * PageHero — consistent premium page header (light).
 * Optional `visual` node renders on the right (technical SVG art).
 */
export const PageHero = ({ micro, title, description, visual, testId }) => {
  return (
    <section
      id={testId}
      data-testid={testId}
      className="relative overflow-hidden border-b border-strato-gray-100 bg-strato-white"
    >
      <Container className="py-16 sm:py-20 lg:py-24">
        <div
          className={cn(
            "grid grid-cols-1 items-center gap-10",
            visual ? "lg:grid-cols-12 lg:gap-14" : "",
          )}
        >
          <div className={visual ? "lg:col-span-7" : "max-w-3xl"}>
            <Reveal>
              {micro ? (
                <MicroLabel variant="blue">{micro}</MicroLabel>
              ) : null}
            </Reveal>
            <Reveal delay={0.06}>
              <h1 className="mt-4 font-display text-4xl font-medium leading-[1.05] tracking-[-0.03em] text-strato-graphite sm:text-5xl lg:text-[3.5rem]">
                {title}
              </h1>
            </Reveal>
            {description ? (
              <Reveal delay={0.12}>
                <p className="mt-5 max-w-[56ch] text-lg leading-[1.6] text-muted-foreground">
                  {description}
                </p>
              </Reveal>
            ) : null}
          </div>
          {visual ? (
            <div className="lg:col-span-5">
              <Reveal delay={0.1}>{visual}</Reveal>
            </div>
          ) : null}
        </div>
      </Container>
    </section>
  );
};
